import { Container } from "./style";

interface Props {
  mensagem: string | JSX.Element;
}

export function TooltipConteudo({ mensagem }: Props) {
  return <Container>{mensagem}</Container>;
}
